
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { showModal } from '@actions/common/actionCreators';
import { commonModalTypes } from '@constants/common/modals/commonModalTypes';
import { get, isPlainObject, set } from '@utils/miscellaneous/objectHelpers';

export const useUploadModal = () => {
    const [ modalData, setModalData ] = useState();
    const dispatch = useDispatch();
    useEffect(() => {
        if(modalData && isPlainObject(modalData)) {

            const {
                enhancements,
                config
            } = modalData;

            enhancements.forEach(({ path = '', add, value }) => {
                let modifiedProp = get(config, path);
                switch(true) {
                    case Array.isArray(modifiedProp):
                        modifiedProp = [
                            ...modifiedProp,
                            ...(add ? [ value ] : [ ...value ])
                        ];
                        break;
                    case isPlainObject(modifiedProp):
                        modifiedProp = {
                            ...modifiedProp,
                            ...value
                        };
                        break;
                    default:
                        modifiedProp = value;
                }
                set(config, path, modifiedProp);
            });

            dispatch(showModal({
                modalType: commonModalTypes.UPLOAD_MODAL,
                modalData: modalData
            }));
        } else {
            return undefined;
        }
    }, [ modalData ]);
    return [ setModalData ];
};